<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <hr>
    <li class="px-3 py-2 hoverBack" (click)="downloadHelp()">
        <i [ngClass]="'pi pi-question'" class="mr-2"></i>
        <span>Ayuda</span>
    </li>
</ul>